import { z } from 'zod';
import { RoleSchema } from './auth';
export const ConsultantProfileInputSchema = z.object({
    certifications: z.array(z.string().max(200)).max(50).default([]),
    specialties: z.array(z.string().max(100)).max(20).optional(),
    signature: z.string().max(2000).optional().nullable(),
    /**
     * @deprecated F33+F34 — tarifa horaria GLOBAL del consultor. La fuente
     * de verdad ahora es UserProjectRole (tarifa+coste POR rol) y el snapshot
     * en OpportunityAssignment. Este campo se mantiene como fallback histórico
     * para TimeEntries pre-F34 sin projectRoleId. No se debe usar para crear
     * nuevos consumidores.
     */
    hourlyRateCents: z.number().int().min(0).nullable().optional(),
});
export const CreateUserSchema = z.object({
    email: z.string().email('Email no válido'),
    fullName: z.string().min(2, 'Nombre demasiado corto').max(200),
    role: RoleSchema,
    /** F45 — Coste interno por hora (céntimos/hora). Aplica a cualquier rol. */
    costPerHourCents: z.number().int().min(0).nullable().optional(),
    /**
     * ¿Percibe rendimientos del trabajo de JR2 (nómina o cargo de administrador)?
     * Es lo que habilita liquidarle kilometraje y dietas EXENTOS en la hoja de
     * gastos: la exención del art. 9 RIRPF es de la relación laboral o
     * estatutaria, no de un socio que le factura a la empresa como profesional.
     */
    receivesExemptAllowances: z.boolean().optional(),
    consultantProfile: ConsultantProfileInputSchema.optional(),
});
export const UpdateUserSchema = z.object({
    fullName: z.string().min(2).max(200).optional(),
    role: RoleSchema.optional(),
    isActive: z.boolean().optional(),
    /** F45 — Coste interno por hora (céntimos/hora). null lo deja sin definir. */
    costPerHourCents: z.number().int().min(0).nullable().optional(),
    /**
     * ¿Percibe rendimientos del trabajo de JR2 (nómina o cargo de administrador)?
     * Es lo que habilita liquidarle kilometraje y dietas EXENTOS en la hoja de
     * gastos: la exención del art. 9 RIRPF es de la relación laboral o
     * estatutaria, no de un socio que le factura a la empresa como profesional.
     */
    receivesExemptAllowances: z.boolean().optional(),
    consultantProfile: ConsultantProfileInputSchema.nullable().optional(),
});
export const UserListItemSchema = z.object({
    id: z.string(),
    email: z.string(),
    fullName: z.string(),
    role: RoleSchema,
    isActive: z.boolean(),
    mustChangePassword: z.boolean(),
    lastLoginAt: z.string().datetime().nullable(),
    isLawyer: z.boolean(),
    /** F45 — Coste interno por hora (céntimos/hora). null = sin definir. */
    costPerHourCents: z.number().int().nullable().optional(),
    /** ¿Percibe rendimientos del trabajo de JR2? Habilita las dietas exentas. */
    receivesExemptAllowances: z.boolean().default(false),
    createdAt: z.string().datetime(),
});
export const UserDetailSchema = UserListItemSchema.extend({
    consultantProfile: z
        .object({
        certifications: z.array(z.string()),
        specialties: z.array(z.string()),
        signature: z.string().nullable(),
        hourlyRateCents: z.number().int().nullable(),
    })
        .nullable(),
});
export const CreateUserResponseSchema = z.object({
    user: UserDetailSchema,
    tempPassword: z.string(),
});
/**
 * Cuerpo (opcional) del reset de contraseña por un ADMIN.
 * `mustChangePassword` por defecto TRUE conserva el comportamiento histórico:
 * la persona debe cambiar la temporal en su próximo acceso. El ADMIN puede
 * ponerlo a false para dejar la temporal como definitiva (p. ej. cuentas de
 * servicio, o cuando ya ha acordado una contraseña con la persona).
 */
export const ResetPasswordSchema = z.object({
    mustChangePassword: z.boolean().default(true),
});
export const ResetPasswordResponseSchema = z.object({
    tempPassword: z.string(),
});
//# sourceMappingURL=users.js.map